import { render, staticRenderFns } from "./ActionCableProvider.vue?vue&type=template&id=ec507858&"
import script from "./ActionCableProvider.vue?vue&type=script&lang=js&"
export * from "./ActionCableProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports